import { Befehl } from '../models'
import { hasBefehlGenericEmptyFields } from './generic'
import { findAuftrag, hasFieldContent } from './helpers'

export function hasBefehl31EmptyFields(befehl: Befehl): boolean {
  if (!befehl.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag3110 = findAuftrag(befehl, '31.10')
  if (auftrag3110) {
    const has3111 = hasFieldContent(auftrag3110, '31.11', 'bf')
    const has3112 = hasFieldContent(auftrag3110, '31.12', 'bft')
    if (!has3111 && !has3112) {
      return true
    }

    const auftrag3115 = findAuftrag(befehl, '31.15')
    const has3116 = hasFieldContent(auftrag3115, '31.16', 'nrEinfahrweiche')
    if (auftrag3115 && !has3116) {
      return true
    }

    const has3113art = hasFieldContent(
      auftrag3110,
      '31.13',
      'zugmeldestelle.art'
    )
    const has3113name = hasFieldContent(
      auftrag3110,
      '31.13',
      'zugmeldestelle.name'
    )
    const has3117 = hasFieldContent(auftrag3110, '31.17', 'uhrzeit')
    if (!has3113art || !has3113name || !has3117) {
      return true
    }
  }

  return false
}
